import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setLatestLocation } from '@/hooks/navigationTracker';

export const NavigationListener = () => {
  const location = useLocation();

  useEffect(() => {
    setLatestLocation(location);
  }, [location]);

  return null;
};
